export { default } from './GlobalStore';



// WEBPACK FOOTER //
// ./src/stores/GlobalStore/index.ts